import React from "react";
import { useNavigate } from "react-router-dom";
import { pipGetAccessToken } from "../utils/pip";
import { pageRoutes } from "../routes/pageRoutes";
import "@fortawesome/fontawesome-free/css/all.min.css";
const Footer = () => {
  const navigate = useNavigate();
  const date = new Date();

  const menuLinks = [
    { name: "Home", href: pageRoutes?.home },
    { name: "About Us", href: pageRoutes?.about },
    { name: "Services", href: pageRoutes?.services },
    { name: "Contact Us", href: pageRoutes?.contactUs },
  ];

  const helpLinks = [
    // { name: "My Account", href: pageRoutes?.profile },
    // { name: "Cart", href: pageRoutes?.cart },
    { name: "Privacy Policy", href: pageRoutes?.privacyPolicy },
    { name: "Terms and Conditions", href: pageRoutes?.more?.glossaryOfTerms },
  ];

  const socialLinks = [
    { platform: "facebook", iconClass: "fa-facebook-f", href: "#" },
    { platform: "twitter", iconClass: "fa-x-twitter", href: "#" },
    { platform: "instagram", iconClass: "fa-instagram", href: "#" },
    { platform: "linkedin", iconClass: "fa-linkedin", href: "#" },
  ];

  return (
    <>
      <footer class="footer-section pb-3">
        <div class="container relative">
          <div class="row  mb-5">
            <div class="col-lg-4 c">
              <div class="mb-4 footer-logo-wrap">
                <a href="#" class="footer-logo">
                  <a
                    class="ct_logo"
                    onClick={() => {
                      navigate(`${pageRoutes?.home}/`);
                    }}
                  >
                    <img src="images/logo.png" alt="" />
                  </a>
                </a>
              </div>
              <p class="mb-4 text-white">
                RobotCombat101.com is a subsidiary of the Advanced Learning
                Project, LLC. Do not copy or duplicate without express written
                permission.
              </p>
            
            </div>
 <div class="col-lg-2 col-md-3 col-sm-6">
                  <h5 class="mb-3  text-white">
                    <strong>Menu Link</strong>
                  </h5>
                  <ul class="list-unstyled">
                    {menuLinks?.map((link, index) => (
                      <li key={index}>
                        <a
                          href="javascript:void(0)"
                          onClick={() => navigate(link?.href)}
                        >
                          {link?.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-6">
                  <h5 class="mb-3  text-white">
                    <strong>Help</strong>
                  </h5>
                  <ul class="list-unstyled">
                    {helpLinks?.map((link, index) => (
                      <li key={index}>
                        <a  href="javascript:void(0)" onClick={() => navigate(link?.href)}>
                          {link?.name}
                        </a>
                      </li>
                    ))}
                  </ul>


                
                </div>
         
           <div class="col-lg-4 col-md-4">
                  <h5 class="mb-3  text-white">
                    <strong>Contact Us</strong>
                  </h5>
                 <p className="text-white">
               
                <a href="mailto:advancedlearningproject@gmail.com">
                  advancedlearningproject@gmail.com
                </a>
              </p>


                    <h5 class="mb-3 mt-4 text-white">
                    <strong>Social Media Links</strong>
                  </h5>
                     <ul class="list-unstyled custom-social ">
                    {socialLinks?.map((link, index) => (
                      <li key={index}>
                        <a href="javascript:void(0)">
                          <i
                            className={`fa fa-brands ${link?.iconClass}`}
                          ></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
          </div>

          <div class="border-top copyright">
            <div class="row pt-4">
              <div class="col-lg-12">
                <p class="mb-2 text-center text-white">
                  Copyright RC101 All Rights Reserved {date?.getFullYear()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {pipGetAccessToken() && (
        <div className="ct_add_classsroom_fixed_btn">
          <button
            onClick={() => {
              navigate(pageRoutes.classroomInvitations);
            }}
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 110 110"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 56.375V97.844L48.531 77.125L11.25 56.375Z"
                fill="white"
              />
              <path
                d="M17.7192 101.406H92.2192L54.9692 80.6865L17.7192 101.406Z"
                fill="white"
              />
              <path
                d="M61.4058 77.0938L98.7498 97.8747V56.3438L61.4058 77.0938Z"
                fill="white"
              />
              <path
                d="M19.7808 46.0938L13.9058 50.6875L19.7808 53.9688V46.0938Z"
                fill="white"
              />
              <path
                d="M90.2192 46.0938V53.9375L96.063 50.6875L90.2192 46.0938Z"
                fill="white"
              />
              <path
                d="M83.9688 57.4058V21.7178C83.9688 19.9678 82.5626 18.5928 80.8438 18.5928H29.1558C27.437 18.5928 26.0308 19.9678 26.0308 21.7178V57.4368L54.9688 73.5308L83.9688 57.4058ZM42.4998 33.6478H67.4998C69.2264 33.6478 70.6248 35.0462 70.6248 36.7728C70.6248 38.4994 69.2264 39.8978 67.4998 39.8978H42.4998C40.7732 39.8978 39.3748 38.4994 39.3748 36.7728C39.3748 35.0462 40.7732 33.6478 42.4998 33.6478ZM39.3748 48.7848C39.3748 47.0582 40.7732 45.6598 42.4998 45.6598H67.4998C69.2264 45.6598 70.6248 47.0582 70.6248 48.7848C70.6248 50.5114 69.2264 51.9098 67.4998 51.9098H42.4998C40.7732 51.9098 39.3748 50.5075 39.3748 48.7848Z"
                fill="white"
              />
            </svg>
            Invitations
          </button>
          <button
            onClick={() => {
              navigate(pageRoutes.courses);
            }}
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1_16)">
                <mask
                  id="mask0_1_16"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="25"
                  height="20"
                >
                  <path
                    d="M24.0006 0.513672H0V19.7141H24.0006V0.513672Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1_16)">
                  <path
                    d="M6.00015 3.32554C6.02515 2.65052 6.26265 2.08801 6.71266 1.638C7.16267 1.18799 7.72519 0.950497 8.4002 0.925537H21.6005C22.2755 0.950497 22.8381 1.18799 23.2881 1.638C23.7381 2.08801 23.9756 2.65052 24.0006 3.32554V14.1258C23.9756 14.8008 23.7381 15.3634 23.2881 15.8134C22.8381 16.2634 22.2755 16.5009 21.6005 16.5259H12.6378C12.1878 15.5509 11.5253 14.7508 10.6502 14.1258H14.4004V12.9258C14.4004 12.5758 14.5129 12.2883 14.7379 12.0633C14.9629 11.8383 15.2504 11.7258 15.6004 11.7258H18.0004C18.3504 11.7258 18.6379 11.8383 18.8629 12.0633C19.0879 12.2883 19.2004 12.5758 19.2004 12.9258V14.1258H21.6005V3.32554H8.4002V5.16311C7.67519 4.73812 6.87517 4.52562 6.00015 4.52562V3.32554ZM6.00015 5.72563C6.65016 5.72563 7.25018 5.88814 7.80019 6.21317C8.3502 6.53813 8.78771 6.97564 9.11272 7.52567C9.43775 8.10066 9.60026 8.70068 9.60026 9.32571C9.60026 9.95075 9.43775 10.5508 9.11272 11.1258C8.78771 11.6758 8.3502 12.1133 7.80019 12.4383C7.25018 12.7633 6.65016 12.9258 6.00015 12.9258C5.35013 12.9258 4.75011 12.7633 4.20011 12.4383C3.65009 12.1133 3.21258 11.6758 2.88757 11.1258C2.56256 10.5508 2.40006 9.95075 2.40006 9.32571C2.40006 8.70068 2.56256 8.10066 2.88757 7.52567C3.21258 6.97564 3.65009 6.53813 4.20011 6.21317C4.75011 5.88814 5.35013 5.72563 6.00015 5.72563ZM4.98762 14.1258H7.01267C8.41271 14.1508 9.58772 14.6383 10.5377 15.5884C11.4878 16.5384 11.9753 17.7134 12.0003 19.1135C11.9503 19.7385 11.6128 20.076 10.9877 20.126H1.01252C0.387509 20.076 0.0500012 19.7385 0 19.1135C0.0250006 17.7134 0.512513 16.5384 1.46254 15.5884C2.41256 14.6383 3.58759 14.1508 4.98762 14.1258Z"
                    fill="#fff"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_1_16">
                  <rect
                    width="24"
                    height="24.0007"
                    fill="white"
                    transform="translate(0 0.519531)"
                  />
                </clipPath>
              </defs>
            </svg>
            Classes
          </button>
        </div>
      )}
    </>
  );
};

export default Footer;
